import TenantPage from 'components/common/TenantPage';
import { useTranslation } from 'react-i18next';
import toast from 'features/toast';
import { medicalServiceEtlFieldService } from 'services/api/MedicalServiceEtlFieldService';
import MedicalServiceEtlFieldsForm from '../MedicalServiceEtlFieldForm';
import { IMedicalServiceEtlField } from 'interfaces';

const initTranscode = {
  id: null,
  field_from: null,
  field_to: null,
  field_to_description: null,
  transcode: null
};

interface CreateMedicalServiceEtlFieldsProps {
  contextType?: 'STANDARD' | 'OLOS';
}

export const CreateMedicalServiceEtlFields = ({
  contextType = 'STANDARD'
}: CreateMedicalServiceEtlFieldsProps) => {
  const translationPrefix =
    contextType === 'OLOS'
      ? 'pages.extra-field-transcode-olos.new'
      : 'pages.extra-field-transcode.new';

  const { t } = useTranslation();

  const createTranscode = async (values) => {
    const field: IMedicalServiceEtlField = {
      id: null,
      field_from: values.field_from,
      field_to: values.field_to.code,
      field_to_description: values.field_to.description,
      transcode: values.transcode,
      context: contextType
    };
    medicalServiceEtlFieldService.add(field).then((res) => {
      if (res) toast.success('Transcodifica aggiunta con successo.');
    });
  };

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}>
      <MedicalServiceEtlFieldsForm transcode={initTranscode} onSubmit={createTranscode} />
    </TenantPage>
  );
};

export default CreateMedicalServiceEtlFields;
